import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-91e42784"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("审核")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重审")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "活动专区商品" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          name: "basic",
          autocomplete: "off",
          layout: "inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "商品名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.searches.goods_name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.goods_name) = $event)),
                  placeholder: "请输入商品名称",
                  style: {"width":"200px"}
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "专区名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.searches.activity_area,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.activity_area) = $event)),
                  style: {"width":"200px"},
                  placeholder: "请选择专区"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areaList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  type: "primary",
                  onClick: $setup.onSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_a_button, {
                  style: {"margin-left":"10px"},
                  onClick: $setup.onReset
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.searches.type,
          "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searches.type) = $event)),
          onChange: $setup.tabChange,
          style: {"margin-top":"30px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeList, (item) => {
              return (_openBlock(), _createBlock(_component_a_tab_pane, {
                key: item.type,
                tab: item.title + '(' + item.count + ')'
              }, null, 8, ["tab"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["activeKey", "onChange"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: $setup.columns,
          bordered: "",
          pagination: $setup.pagination,
          onChange: $setup.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'image')
              ? (_openBlock(), _createBlock(_component_a_image, {
                  key: 0,
                  src: record.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    onClick: ($event: any) => ($setup.getDetail(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (_ctx.searches.type == 0)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        style: {"margin":"5px"},
                        onClick: ($event: any) => ($setup.examine(record))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.searches.type == 2)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        size: "small",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.visible) = $event)),
      title: "商品审核",
      width: "30%",
      "ok-text": "通过",
      "cancel-text": "拒绝",
      onOk: _cache[5] || (_cache[5] = ($event: any) => ($setup.onSubmit(1))),
      onCancel: _cache[6] || (_cache[6] = ($event: any) => ($setup.onSubmit(2)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          value: _ctx.suppose,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.suppose) = $event)),
          placeholder: "请输入审核意见",
          rows: 4
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      title: _ctx.title,
      visible: _ctx.visible2,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.visible2) = $event)),
      width: "50%",
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_descriptions, {
          title: "订单信息",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions_item, { label: "专区名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.orderData.activity_area_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "商品名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.orderData.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "店铺名称" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.orderData.shop_name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "封面图" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_image, {
                  src: _ctx.orderData.image,
                  style: {"width":"50px"}
                }, null, 8, ["src"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "最高价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.orderData.max_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "最低价" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.orderData.min_price), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.orderData.audit_status), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_descriptions_item, { label: "审核意见" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.orderData.audit_remark), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "visible"])
  ]))
}